const mainUrl = "https://api.theskunkertons.com/api/";
// const mainUrl = "https://theskunkertons.com/api/";

export default mainUrl;
